const faDirectoryBrowse: Record<
  string,
  { message: string; description: string }
> = {
  "ledgerEditor.cloneRepository": {
    message: "کپی مخزن",
    description: "Header for clone repository dialog",
  },
  "ledgerEditor.downloadZip": {
    message: "دانلود ZIP",
    description: "Menu item to download as ZIP",
  },
  "ledgerEditor.manageSshKeys": {
    message: "مدیریت کلیدهای SSH",
    description: "Menu item for SSH key management",
  },
  "ledgerEditor.thisDirectoryIsEmpty": {
    message: "این پوشه خالی است",
    description: "Message shown when directory has no contents",
  },
};

export default faDirectoryBrowse;
